/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { GET_LISTDATA } from "../../actions";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { apiUrl, adminlimit, headerconfig } from "../Settings/Config";
import { format } from "date-fns";
import {
  showContaimerLoader,
  userID,
  showPriceValue,
  encodeValue,
} from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
var module = "reports/";
var moduleName = "Sales Statistics Report";

class List extends Component {
  constructor(props) {
    super(props);
    console.log(this.props, "this.props");
    let reportType = this.props.match.params?.reportType || "";
    this.state = {
      userID: userID(),
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      totalSale:0,
      currentPage: 1,
      listdata: [],

      recivedloading: true,
      recivedtotalRecords: 0,
      recivedtotalPage: 0,
      totalRecivedAmount:0,
      recivedcurrentPage: 1,
      recivedlistdata: [],

      pendingloading: true,
      pendingtotalRecords: 0,
      pendingtotalPage: 0,
      balanceBillAmount:0,
      pendingcurrentPage: 1,
      pendinglistdata: [],

      reportType: reportType,
      start_date: "",
      end_date: "",
      customer: "",
      customerList: [],
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadCustomer();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.listdata !== this.state.listdata) {
      this.setState({
        listdata: nextProps.listdata,
        loading: false,
        totalRecords: nextProps.totalRecords,
        totalPage: nextProps.totalPages,
        totalSale: nextProps.totalSale,
      });
    }

    let reportType = nextProps.match.params?.reportType || "";
    if(reportType!==this.state.reportType) {
        this.setState({reportType: reportType})
    }

  }
  searchList() {
    this.setState({ loading: true, recivedloading:true, pendingloading:true }, function () {
      this.loadList(1);
      this.loadRecivedList(1);
      this.loadPendingList(1);
      
    });
  }
  
  resetSearch() {
    this.setState(
      {
        loading: true,
        recivedloading:true,
        pendingloading:true,
        start_date: "",
        end_date: "",
        customer: "",
      },
      function () {
        this.loadList(1);
        this.loadRecivedList(1);
        this.loadPendingList(1);
      }
    );
  }
  loadList(offset) {
    var addParams = "";
    if (this.state.customer?.value) {
      addParams += "&customer=" + this.state.customer.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }
    var params = {
      params:
        "limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams,
      url: apiUrl + "reports/sales",
    };
    this.props.getListData(params);
  }


  loadRecivedList(offset) {
    var addParams = "";
    if (this.state.customer?.value) {
      addParams += "&customer=" + this.state.customer.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }   

    var urlShringTxt =
      apiUrl + "reports/recivedsales?limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        var result = res.data.result;       
        this.setState({recivedloading:false, recivedlistdata:result, recivedtotalRecords:res.data.totalRecords, recivedtotalPage:res.data.totalPages, totalRecivedAmount:res.data.totalRecivedAmount})       
      } else {
        this.setState({recivedloading:false, recivedlistdata:[],  recivedtotalRecords: 0, recivedtotalPage: 0, totalRecivedAmount:0})
      }
    });
  }

  loadPendingList(offset) {
    var addParams = "";
    if (this.state.customer?.value) {
      addParams += "&customer=" + this.state.customer.value;
    }

    if (this.state.start_date) {
      addParams +=
        "&start_date=" + format(new Date(this.state.start_date), "yyyy-MM-dd");
    }
    if (this.state.end_date) {
      addParams +=
        "&end_date=" + format(new Date(this.state.end_date), "yyyy-MM-dd");
    }   

    var urlShringTxt =
      apiUrl + "reports/pendingsales?limit=" +
        adminlimit +
        "&offset=" +
        offset +
        "&userID=" +
        this.state.userID +
        addParams;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        var result = res.data.result;       
        this.setState({pendingloading:false, pendinglistdata:result, pendingtotalRecords:res.data.totalRecords, pendingtotalPage:res.data.totalPages, balanceBillAmount:res.data.balanceBillAmount})       
      } else {
        this.setState({pendingloading:false, pendinglistdata:[],  pendingtotalRecords: 0, pendingtotalPage: 0, balanceBillAmount:0})
      }
    });
  }

  loadCustomer() {
    var urlShringTxt =
      apiUrl + "customer/dropdownlist?&userID=" + this.state.userID;
    axios.get(urlShringTxt, headerconfig).then((res) => {
      if (res.data.status === "ok") {
        var result = res.data.result;
        var customer = "";
        if (result.length > 0) {
          result.map((item) => {
            if (item.value === this.state.customerID) {
              customer = item;
            }
          });
        }
        this.setState(
          { customerList: res.data.result, customer: customer },
          () => {
            this.loadList(1);
            this.loadRecivedList(1);
            this.loadPendingList(1);
            
          }
        );
      } else {
        this.loadList(1);
        this.loadRecivedList(1);
      }
    });
  }
  sateValChange = (field, value, additionalParam) => {
    if (field === "page" && additionalParam==='totalsale') {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        function () {
          this.loadList(value);
        }
      );
    }else  if (field === "page" && additionalParam==='recived') {
      this.setState(
        {
          recivedloading: true,
          recivedcurrentPage: value,
        },
        function () {
          this.loadRecivedList(value);
        }
      );
    }else  if (field === "page" && additionalParam==='pending') {
      this.setState(
        {
          pendingloading: true,
          pendingcurrentPage: value,
        },
        function () {
          this.loadPendingList(value);
        }
      );
    }
  };
  handleChangeText(event) {
    var name = event.target.name;
    var value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  handleChangeDate(name, value) {
    this.setState({ [name]: value });
  }

  gotoDetails() {

  }

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage="statistics-report" />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid">
                  <div className="page-header">
                    <h1 className="page-title">{moduleName}</h1>
                  </div>

                  <div className="row">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="form-row">
                            <div className="col-md-3">
                              <Select
                                value={this.state.customer}
                                onChange={this.handleSelectChange.bind(
                                  this,
                                  "customer"
                                )}
                                placeholder="Select Customer"
                                isClearable={true}
                                options={this.state.customerList}
                              />
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.start_date}
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "start_date"
                                  )}
                                />
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-floating form-floating-outline">
                                <DatePicker
                                  peekNextMonth
                                  showMonthDropdown
                                  showYearDropdown
                                  dropdownMode="select"
                                  className="form-control"
                                  selected={this.state.end_date}
                                  minDate={
                                    this.state.start_date !== ""
                                      ? this.state.start_date
                                      : ""
                                  }
                                  dateFormat="dd-MM-yyyy"
                                  placeholderText="Start Date"
                                  onChange={this.handleChangeDate.bind(
                                    this,
                                    "end_date"
                                  )}
                                />
                              </div>
                            </div>

                            <div className="col-md-3">
                              <a
                                href={void 0}
                                className="btn btn-primary"
                                onClick={this.searchList.bind(this)}
                              >
                                Search
                              </a>
                              <a
                                href={void 0}
                                className="btn btn-secondary offset-1"
                                onClick={this.resetSearch.bind(this)}
                              >
                                Reload
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-menu-heading">
                    <div class="tabs-menu">                        
                        <ul class="nav panel-tabs panel-secondary">
                            <li>
                                <Link to={`/report/statistics/sale/totalsale`} class={this.state.reportType==='totalsale'?"active":''}>
                                    <span>
                                        <i class="fe fe-user me-1"></i>
                                    </span>
                                    Total Salse
                                </Link>
                            </li>
                            <li>
                              <Link to={`/report/statistics/sale/recived`} class={this.state.reportType==='recived'?"active":''}>
                                    <span>
                                        <i class="fe fe-user me-1"></i>
                                    </span>
                                    Recived Bill
                              </Link>
                            </li>
                            <li>
                              <Link to={`/report/statistics/sale/pending`} class={this.state.reportType==='pending'?"active":''}>
                                    <span>
                                        <i class="fe fe-user me-1"></i>
                                    </span>
                                    Receivable Bill
                              </Link>
                            </li>
                            
                        </ul>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        {this.state.reportType==='totalsale' && (
                          <div>
                            {this.state.loading ? (
                              showContaimerLoader()
                            ) : (
                              <div>
                                {parseInt(this.state.totalPage) > 0 && (
                                  <div className="card-header">
                                    <h3 className="card-title" style={{width:'80%'}}>
                                      <b>{this.state.currentPage}</b> -{" "}
                                      <b> {this.state.totalPage}</b> of{" "}
                                      <b> {this.state.totalRecords} </b>
                                      Total Salse
                                    </h3>
                                    <div className="float-sm-end ">
                                      <h3 className="card-title float-sm-end">Total Salse: {showPriceValue(this.state.totalSale)}</h3>
                                    </div>
                                    
                                  </div>
                                )}
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table text-nowrap text-md-nowrap mb-0">
                                      <thead>
                                        <tr>
                                          <th>Invoice</th>
                                          <th>Sale No.</th>
                                          <th>Invoice No.</th>
                                          <th>Sale Amount</th>
                                          <th>Sale Type</th>
                                          <th>Customer</th>
                                          <th>Contact</th>
                                          <th>Phone</th>                                      
                                          <th>Start Date</th>
                                          <th>End Date</th>
                                          <th>Sale Date</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.listdata.length > 0 ? (
                                          this.state.listdata.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <Link
                                                    className="btn btn-primary"
                                                    to={`/sale/invoice/${encodeValue(
                                                      item.saleHistoryID
                                                    )}/history`}
                                                    target="_blank"
                                                  >
                                                    View Invoice
                                                  </Link>
                                                </td>
                                                <td>{item.saleNumber}</td>
                                                <td>{item.saleInvoice}</td>
                                                <td>
                                                  {showPriceValue(item.salePrice)}
                                                </td>
                                                <td>{item.saleType}</td>
                                                <td>{item.customerName}</td>
                                                <td>
                                                  {item.customerContactPerson}
                                                </td>
                                                <td>{item.customerMobile}</td>                                                
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(item.startDate),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(item.endDate),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(
                                                          item.saleCreatedON
                                                        ),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td className="text-center" colSpan={11}>
                                              No {moduleName} Found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.totalRecords,
                                      totalPage: this.state.totalPage,
                                      currentPage: this.state.currentPage,
                                      additionalParam:'totalsale',
                                    }}                                    
                                    sateValChange={this.sateValChange}
                                  />
                                  
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.reportType==='recived' && (
                          <div>
                            {this.state.recivedloading ? (
                              showContaimerLoader()
                            ) : (
                              <div>
                                {parseInt(this.state.recivedtotalPage) > 0 && (
                                  <div className="card-header">
                                    <h3 className="card-title" style={{width:'80%'}}>
                                      <b>{this.state.recivedcurrentPage}</b> -{" "}
                                      <b> {this.state.recivedtotalPage}</b> of{" "}
                                      <b> {this.state.recivedtotalRecords} </b>
                                      Recived Bill
                                    </h3>
                                    <div className="float-sm-end ">
                                      <h3 className="card-title float-sm-end">Total Recived Amount: {showPriceValue(this.state.totalRecivedAmount)}</h3>
                                    </div>
                                  </div>
                                )}
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table text-nowrap text-md-nowrap mb-0">
                                      <thead>
                                        <tr>
                                          <th>Sale No.</th>
                                          <th>Invoice No.</th>
                                          <th>Sale Amount</th>
                                          <th>Recived Amount</th>
                                          <th>Modeof Payment</th>
                                          <th>Payment Reference Number</th>
                                          <th>Payment Date</th>
                                          <th>Sale Type</th>
                                          <th>Customer</th>
                                          <th>Contact</th>
                                          <th>Phone</th>                                      
                                          <th>Start Date</th>
                                          <th>End Date</th>
                                          <th>Sale Date</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.recivedlistdata.length > 0 ? (
                                          this.state.recivedlistdata.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>{item.saleNumber}</td>
                                                <td>{item.saleInvoice}</td>
                                                <td>
                                                  <b>{showPriceValue(item.salePrice)}</b>
                                                </td>
                                                <td>
                                                  <b>{showPriceValue(item.amount)}</b>
                                                </td>
                                                <td>{item.modeofPayment}</td>
                                                <td>{item.paymentReferenceNumber}</td>
                                                <td>
                                                  {item.amountCreatedOn !== ""
                                                    ? format(
                                                        new Date(item.amountCreatedOn),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>{item.saleType}</td>
                                                <td>{item.customerName}</td>
                                                <td>
                                                  {item.customerContactPerson}
                                                </td>
                                                <td>{item.customerMobile}</td>
                                                
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(item.startDate),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(item.endDate),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(
                                                          item.saleCreatedON
                                                        ),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td className="text-center" colSpan={11}>
                                              No {moduleName} Found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.recivedtotalRecords,
                                      totalPage: this.state.recivedtotalPage,
                                      currentPage: this.state.recivedcurrentPage,
                                      additionalParam:'recived'
                                    }}
                                    sateValChange={this.sateValChange}
                                  />                                  
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.reportType==='pending' && (
                          <div>
                            {this.state.pendingloading ? (
                              showContaimerLoader()
                            ) : (
                              <div>
                                {parseInt(this.state.pendingtotalPage) > 0 && (
                                  <div className="card-header">
                                    <h3 className="card-title" style={{width:'75%'}}>
                                      <b>{this.state.pendingcurrentPage}</b> -{" "}
                                      <b> {this.state.pendingtotalPage}</b> of{" "}
                                      <b> {this.state.pendingtotalRecords} </b>
                                      Receivable Bill
                                    </h3>
                                    <div className="float-sm-end ">
                                      <h3 className="card-title float-sm-end">Total Receivable Amount: {showPriceValue(this.state.balanceBillAmount)}</h3>
                                    </div>
                                  </div>
                                )}
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table text-nowrap text-md-nowrap mb-0">
                                      <thead>
                                        <tr>
                                          <th>Invoice</th>
                                          <th>Sale No.</th>
                                          <th>Invoice No.</th>
                                          <th>Sale Amount</th>
                                          <th>Balance Amount</th>                                          
                                          <th>Sale Type</th>
                                          <th>Customer</th>
                                          <th>Contact</th>
                                          <th>Phone</th>                                      
                                          <th>Start Date</th>
                                          <th>End Date</th>
                                          <th>Sale Date</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.pendinglistdata.length > 0 ? (
                                          this.state.pendinglistdata.map((item, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>
                                                  <Link
                                                    className="btn btn-primary"
                                                    to={`/sale/invoice/${encodeValue(
                                                      item.saleHistoryID
                                                    )}/history`}
                                                    target="_blank"
                                                  >
                                                    View Invoice
                                                  </Link>
                                                </td>
                                                <td>{item.saleNumber}</td>
                                                <td>{item.saleInvoice}</td>
                                                <td>
                                                  {showPriceValue(item.salePrice)}
                                                </td>
                                                <td>
                                                  {showPriceValue(item.saleBalanceAmount)}
                                                </td>
                                                <td>{item.saleType}</td>
                                                <td>{item.customerName}</td>
                                                <td>
                                                  {item.customerContactPerson}
                                                </td>
                                                <td>{item.customerMobile}</td>
                                                
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(item.startDate),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(item.endDate),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                                <td>
                                                  {item.saleCreatedON !== ""
                                                    ? format(
                                                        new Date(
                                                          item.saleCreatedON
                                                        ),
                                                        "dd-MM-yyyy"
                                                      )
                                                    : ""}
                                                </td>
                                              </tr>
                                            );
                                          })
                                        ) : (
                                          <tr>
                                            <td className="text-center" colSpan={12}>
                                              No Receivable Bill Found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                  <Pagenation
                                    params={{
                                      totalRecords: this.state.pendingtotalRecords,
                                      totalPage: this.state.pendingtotalPage,
                                      currentPage: this.state.pendingcurrentPage,
                                      additionalParam:'pending'
                                    }}
                                    sateValChange={this.sateValChange}
                                  />                                  
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  var listdata = Array();
  var listdataStatus = "";
  var totalPages = 0;
  var totalRecords = 0;
  var totalSale = 0;
  if (Object.keys(state.listdata).length > 0) {
    listdataStatus = state.listdata[0].status;
    if (state.listdata[0].status === "ok") {
      listdata = state.listdata[0].result;
      totalPages = state.listdata[0].totalPages;
      totalRecords = state.listdata[0].totalRecords;
      totalSale = state.listdata[0].totalSale;
    }
  }
  return {
    listdata: listdata,
    totalPages: totalPages,
    totalRecords: totalRecords,
    totalSale:totalSale
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListData: (datas) => {
      dispatch({ type: GET_LISTDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(List);
